export default class Buttons {
	static init() {
		this.buttons = document.querySelectorAll(".btn, .btn-fill, .btn-stroke, .btn-light");

		this.buttons.forEach( (button) => {

			const text = `<span class='label'>${button.innerHTML}</span>`;
			button.innerHTML = text;

			if( button.classList.contains('btn-go') || button.classList.contains('btn-back') ){
				const element = document.createElement("span");
				element.innerHTML = `<svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
<path  d="M-2.62268e-07 6.5354C-2.80374e-07 6.12119 0.335786 5.7854 0.75 5.7854L11.3879 5.7854L7.23017 1.82602C6.93159 1.53893 6.92228 1.06415 7.20937 0.765567C7.49647 0.466989 7.97125 0.457679 8.26983 0.744774L13.7698 5.99477C13.9169 6.13618 14 6.33139 14 6.5354C14 6.73941 13.9169 6.93462 13.7698 7.07602L8.26983 12.326C7.97125 12.6131 7.49647 12.6038 7.20938 12.3052C6.92228 12.0067 6.93159 11.5319 7.23017 11.2448L11.3879 7.2854L0.75 7.2854C0.335786 7.2854 -2.44163e-07 6.94961 -2.62268e-07 6.5354Z" fill="#6AD724"/>
</svg>`;
				element.classList.add('svg');
				button.appendChild(element);
			}

			if( button.classList.contains('btn-download') ){
				const element = document.createElement("span");
				element.innerHTML = `<svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.5 0.0666504C6.91421 0.0666504 7.25 0.402437 7.25 0.81665V11.4546L11.2094 7.29682C11.4965 6.99824 11.9713 6.98893 12.2698 7.27603C12.5684 7.56312 12.5777 8.0379 12.2906 8.33648L7.04063 13.8365C6.89922 13.9835 6.70401 14.0667 6.5 14.0667C6.29599 14.0667 6.10078 13.9835 5.95938 13.8365L0.709376 8.33648C0.422281 8.0379 0.431591 7.56312 0.730169 7.27603C1.02875 6.98893 1.50353 6.99824 1.79063 7.29682L5.75 11.4546V0.81665C5.75 0.402437 6.08579 0.0666504 6.5 0.0666504Z" fill="currentColor"/>
<path d="M0.25 17.0042C0.25 16.5899 0.585786 16.2542 1 16.2542H13C13.4142 16.2542 13.75 16.5899 13.75 17.0042C13.75 17.4184 13.4142 17.7542 13 17.7542H1C0.585786 17.7542 0.25 17.4184 0.25 17.0042Z" fill="currentColor"/>
</svg>`;
				element.classList.add('svg');
				button.appendChild(element);
			}



			if( button.classList.contains('btn-play') ){
				const element = document.createElement("span");
				element.innerHTML = `<svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M1.75 2.26341V11.7366L10.4338 7.00001L1.75 2.26341ZM0.25 1.16846C0.25 0.523259 0.940608 0.113296 1.50702 0.42225L12.1982 6.2538C12.7888 6.57596 12.7888 7.42405 12.1982 7.74622L1.50702 13.5778C0.940606 13.8867 0.25 13.4768 0.25 12.8316V1.16846Z" fill="currentColor"/>
</svg>`;
				element.classList.add('svg');
				button.appendChild(element);
			}

			if( button.classList.contains('btn-lang') ){
				const element = document.createElement("span");
				element.innerHTML = `<svg width="15" height="10" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.08786 0.982932L8.15892 8.054L7.07107 9.14186L0 2.07079L1.08786 0.982932Z" fill="#34847A"/>
<path d="M14.1422 2.07077L7.07107 9.14186L5.98332 8.05398L13.0544 0.98291L14.1422 2.07077Z" fill="#34847A"/>
</svg>`;
				element.classList.add('svg');
				button.appendChild(element);
			}

		});

	}

}
